function _templateObject12() {
  var data = _taggedTemplateLiteral(["\n        margin-left: ", ";\n      "]);

  _templateObject12 = function _templateObject12() {
    return data;
  };

  return data;
}

function _templateObject11() {
  var data = _taggedTemplateLiteral(["\n        margin-bottom: ", ";\n      "]);

  _templateObject11 = function _templateObject11() {
    return data;
  };

  return data;
}

function _templateObject10() {
  var data = _taggedTemplateLiteral(["\n        margin-right: ", ";\n      "]);

  _templateObject10 = function _templateObject10() {
    return data;
  };

  return data;
}

function _templateObject9() {
  var data = _taggedTemplateLiteral(["\n        margin-top: ", ";\n      "]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = _taggedTemplateLiteral(["\n        margin-top: ", ";\n        margin-bottom: ", ";\n      "]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n        margin-left: ", ";\n        margin-right: ", ";\n      "]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n        padding-left: ", ";\n      "]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n        padding-bottom: ", ";\n      "]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n        padding-right: ", ";\n      "]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n        padding-top: ", ";\n      "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n        padding-top: ", ";\n        padding-bottom: ", ";\n      "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n        padding-left: ", ";\n        padding-right: ", ";\n      "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

import styled from 'styled-components';
import { getMultipliedIndent, getMargin } from "../../theme/selectors";
import { mediaSmDown } from "../../theme/helpers/media";
import { addStyleIfPropTruly } from "../../utils/styledComponents";
import { createBoxIndentStyles, addHideStyles } from "./utils/boxStyles";
var Box = styled.div.withConfig({
  displayName: "Box",
  componentId: "l1l2g5-0"
})(["box-sizing:border-box;", ";", ";", " ", " ", " ", " ", " ", " ", " ", " ", " ", " ", " ", " ", " ", " ", ""], createBoxIndentStyles, addHideStyles, function (_ref) {
  var width = _ref.width;
  return width && "width: ".concat(width, ";");
}, function (_ref2) {
  var maxWidth = _ref2.maxWidth;
  return maxWidth && "max-width: ".concat(maxWidth, ";");
}, addStyleIfPropTruly('flex', 'display: flex'), function (_ref3) {
  var pxXs = _ref3.pxXs,
      theme = _ref3.theme;

  if (pxXs !== undefined) {
    var indent = getMultipliedIndent(theme, pxXs);
    return mediaSmDown(_templateObject(), indent, indent);
  }
}, function (_ref4) {
  var pyXs = _ref4.pyXs,
      theme = _ref4.theme;

  if (pyXs !== undefined) {
    var indent = getMultipliedIndent(theme, pyXs);
    return mediaSmDown(_templateObject2(), indent, indent);
  }
}, function (_ref5) {
  var ptXs = _ref5.ptXs,
      theme = _ref5.theme;

  if (ptXs !== undefined) {
    var indent = getMultipliedIndent(theme, ptXs);
    return mediaSmDown(_templateObject3(), indent);
  }
}, function (_ref6) {
  var prXs = _ref6.prXs,
      theme = _ref6.theme;

  if (prXs !== undefined) {
    var indent = getMultipliedIndent(theme, prXs);
    return mediaSmDown(_templateObject4(), indent);
  }
}, function (_ref7) {
  var pbXs = _ref7.pbXs,
      theme = _ref7.theme;

  if (pbXs !== undefined) {
    var indent = getMultipliedIndent(theme, pbXs);
    return mediaSmDown(_templateObject5(), indent);
  }
}, function (_ref8) {
  var plXs = _ref8.plXs,
      theme = _ref8.theme;

  if (plXs !== undefined) {
    var indent = getMultipliedIndent(theme, plXs);
    return mediaSmDown(_templateObject6(), indent);
  }
}, function (_ref9) {
  var mxXs = _ref9.mxXs,
      theme = _ref9.theme;

  if (mxXs !== undefined) {
    var indent = getMargin(theme, mxXs);
    return mediaSmDown(_templateObject7(), indent, indent);
  }
}, function (_ref10) {
  var myXs = _ref10.myXs,
      theme = _ref10.theme;

  if (myXs !== undefined) {
    var indent = getMargin(theme, myXs);
    return mediaSmDown(_templateObject8(), indent, indent);
  }
}, function (_ref11) {
  var mtXs = _ref11.mtXs,
      theme = _ref11.theme;

  if (mtXs !== undefined) {
    var indent = getMargin(theme, mtXs);
    return mediaSmDown(_templateObject9(), indent);
  }
}, function (_ref12) {
  var mrXs = _ref12.mrXs,
      theme = _ref12.theme;

  if (mrXs !== undefined) {
    var indent = getMargin(theme, mrXs);
    return mediaSmDown(_templateObject10(), indent);
  }
}, function (_ref13) {
  var mbXs = _ref13.mbXs,
      theme = _ref13.theme;

  if (mbXs !== undefined) {
    var indent = getMargin(theme, mbXs);
    return mediaSmDown(_templateObject11(), indent);
  }
}, function (_ref14) {
  var mlXs = _ref14.mlXs,
      theme = _ref14.theme;

  if (mlXs !== undefined) {
    var indent = getMargin(theme, mlXs);
    return mediaSmDown(_templateObject12(), indent);
  }
});
export var BoxFiller = styled.div.withConfig({
  displayName: "Box__BoxFiller",
  componentId: "l1l2g5-1"
})(["background-color:#e0e9e9;color:#004b46;border-radius:12px;min-width:150px;min-height:150px;display:flex;align-items:center;justify-content:center;"]);
export default Box;